/**
 * Blue Moon Black Friday iFrame Embed Script
 * Automatically adjusts iframe height to match content
 * 
 * Usage in Shopify:
 * 1. Add this script to assets folder
 * 2. Include in your template before the iframe
 * 3. Add data-bf-iframe attribute to your iframe element
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    iframeSelector: '[data-bf-iframe]',
    minHeight: 400,
    updateInterval: 250, // ms between height checks
    resizeDebounce: 150, // ms debounce for window resize
  };

  /**
   * Initialize iframe height management
   */
  function initIframeHeight() {
    const iframes = document.querySelectorAll(CONFIG.iframeSelector);
    
    if (iframes.length === 0) {
      console.warn('Black Friday iframe not found. Make sure to add data-bf-iframe attribute.');
      return;
    }

    iframes.forEach(iframe => {
      setupIframe(iframe);
    });
  }

  /**
   * Setup individual iframe
   */
  function setupIframe(iframe) {
    // Ensure iframe has necessary attributes
    iframe.style.width = '100%';
    iframe.style.border = 'none';
    iframe.style.display = 'block';
    iframe.style.overflow = 'hidden';
    
    // Set initial height
    iframe.style.height = CONFIG.minHeight + 'px';

    // Listen for messages from iframe content
    window.addEventListener('message', function(event) {
      handleMessage(event, iframe);
    });

    // Handle iframe load
    iframe.addEventListener('load', function() {
      onIframeLoad(iframe);
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        requestHeightUpdate(iframe);
      }, CONFIG.resizeDebounce);
    });
  }

  /**
   * Handle iframe load event
   */
  function onIframeLoad(iframe) {
    console.log('Black Friday iframe loaded');
    
    // Initial height request
    setTimeout(() => {
      requestHeightUpdate(iframe);
    }, 100);

    // Set up periodic height checks (for dynamic content)
    setInterval(() => {
      requestHeightUpdate(iframe);
    }, CONFIG.updateInterval);
  }

  /**
   * Request height update from iframe
   */
  function requestHeightUpdate(iframe) {
    try {
      iframe.contentWindow.postMessage({
        type: 'REQUEST_HEIGHT',
        source: 'bluemoon-parent'
      }, '*');
    } catch (e) {
      console.warn('Could not request height from iframe:', e);
    }
  }

  /**
   * Handle messages from iframe
   */
  function handleMessage(event, iframe) {
    // Security check - adjust origin as needed
    // if (event.origin !== 'https://your-lovable-domain.com') return;

    const data = event.data;
    
    if (data.type === 'CONTENT_HEIGHT' && data.source === 'bluemoon-iframe') {
      updateIframeHeight(iframe, data.height);
    }
  }

  /**
   * Update iframe height
   */
  function updateIframeHeight(iframe, height) {
    const newHeight = Math.max(height, CONFIG.minHeight);
    
    if (iframe.style.height !== newHeight + 'px') {
      iframe.style.height = newHeight + 'px';
      console.log('Updated iframe height to:', newHeight);
    }
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIframeHeight);
  } else {
    initIframeHeight();
  }

  // Expose manual refresh function
  window.refreshBlackFridayIframe = function() {
    const iframes = document.querySelectorAll(CONFIG.iframeSelector);
    iframes.forEach(iframe => {
      requestHeightUpdate(iframe);
    });
  };

})();
